























































import { isEqual } from 'lodash-es'
import { Button, Checkbox, Icon } from '@alpha/ink'
import ListItem from '@/components/ListItem.vue'
import FilterBar from '@/components/FilterBar.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { AudienceCriteria, AudienceCriteriaType, criteriaGroups, CriteriaGroupType } from './Audience'

@Component({
  components: {
    Button,
    ListItem,
    FilterBar,
    Checkbox,
    Icon
  }
})
export default class AudienceBuilderSidebar extends Vue {
  @Prop({ required: true }) readonly criteria!: AudienceCriteria
  @Prop({ required: true }) readonly defaultCriteria!: AudienceCriteria
  @Prop({ required: true }) readonly activeCriteriaTypes!: AudienceCriteriaType[]

  filterOrder = []

  visibleCriteriaGroups: Record<CriteriaGroupType, boolean> = {
    [CriteriaGroupType.DEMOGRAPHIC]: true,
    [CriteriaGroupType.PROFESSIONAL]: false,
    [CriteriaGroupType.OTHER]: false
  }

  requiredCriteriaTypes = [
    AudienceCriteriaType.AGE,
    AudienceCriteriaType.GEOGRAPHIC_LOCATION
  ]

  criteriaGroups = criteriaGroups
  AudienceCriteriaType = AudienceCriteriaType

  get moreInfoTooltip () {
    return 'Can’t find the filter criteria you need? Create your own and our researchers will create screener questions for you.'
  }

  tooltipText (criteriaType: AudienceCriteriaType) {
    if (this.requiredCriteriaTypes.includes(criteriaType)) {
      return 'Default filters can be edited in the filter cards on the right but cannot be removed.'
    } else {
      return false
    }
  }

  sentenceCase (title: string) {
    const words = title.split(' ')
    if (words.length > 1) {
      const sentenceCase = words.map((word, index) => {
        if (index) {
          return word.toLowerCase()
        } else {
          return word
        }
      })
      return sentenceCase.join(' ')
    } else {
      return words.join(' ')
    }
  }

  isAgeOrGeo (criteriaType: AudienceCriteriaType) {
    return criteriaType === AudienceCriteriaType.AGE || criteriaType === AudienceCriteriaType.GEOGRAPHIC_LOCATION
  }

  toggleCriteriaGroupVisibility (criteriaGroupType: CriteriaGroupType) {
    this.visibleCriteriaGroups[criteriaGroupType] = !this.visibleCriteriaGroups[criteriaGroupType]
  }

  updateCriteria (updatedCriteria: Partial<AudienceCriteria>) {
    this.$emit('updateCriteria', updatedCriteria)
  }

  isCriteriaTypeActive (criteriaType: AudienceCriteriaType) {
    return this.activeCriteriaTypes.includes(criteriaType)
  }

  setCriteriaTypeActive (criteriaType: AudienceCriteriaType, active: boolean) {
    this.$emit('setCriteriaTypeActive', criteriaType, active)
  }

  toggleCriteriaTypeActive (criteriaType: AudienceCriteriaType) {
    this.setCriteriaTypeActive(criteriaType, !this.isCriteriaTypeActive(criteriaType))
  }

  getCriteriaTypeDefault (criteriaType: AudienceCriteriaType) {
    switch (criteriaType) {
      case AudienceCriteriaType.AGE: return 'Default: 18-75 yrs'
      case AudienceCriteriaType.GEOGRAPHIC_LOCATION: return 'Default: USA'
    }

    if (!this.isCriteriaTypeActive(criteriaType)) return 'Any'
  }

  getCriteriaTypeStatus (criteriaType: AudienceCriteriaType) {
    if (!this.isCriteriaTypeActive(criteriaType)) return undefined

    const hasCriteriaChanged = !isEqual(this.criteria[criteriaType], this.defaultCriteria[criteriaType])

    if (hasCriteriaChanged) {
      switch (criteriaType) {
        case AudienceCriteriaType.GEOGRAPHIC_LOCATION:
        case AudienceCriteriaType.AGE:
          return '- Edited'
        case AudienceCriteriaType.US_HHI: {
          const value = this.criteria[criteriaType]
          if (value !== undefined) {
            const [start, end] = value
            const isHHIUnselected = (start === 0) && (end === 0)
            return isHHIUnselected ? 'Select filters' : 'Selected'
          }
          break
        }
        default: {
          const value = this.criteria[criteriaType]
          return !value || value.length === 0 ? 'Select filters' : `${value.length} selected`
        }
      }
    }
  }
}
